import React from 'react';

const ArrowRightIcon = ({ width = 14, height = 14, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    className={className}
  >
    <path
      d="M9.43359 6.41672L6.30459 3.28772L7.12942 2.46289L11.6666 7.00006L7.12942 11.5372L6.30459 10.7124L9.43359 7.58339H2.33325V6.41672H9.43359Z"
      fill="black"
    />
  </svg>
);

export default ArrowRightIcon;
